import { COMPONENT_TYPES } from '../../../constants';
import PaymentFailComponent from './PaymentFail.component';
import PaymentFailEditor from './PaymentFail.editor';
import PaymentFailProperties from './PaymentFail.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PAYMENT_FAIL, // constants.js에 정의된 타입 상수 사용
  component: PaymentFailComponent,
  editorComponent: PaymentFailEditor,
  properties: PaymentFailProperties,
  defaultProps: {
    // 기본 속성 정의
    style: {
      width: '100%',
      padding: '40px 0',
      backgroundColor: 'transparent'
    },
    componentProps: {
      className: 'payment-fail-wrapper',
      title: '결제에 실패했습니다',
      errorDefaultMessage: '결제 처리 중 오류가 발생했습니다.',
      cartButtonText: '장바구니로 돌아가기',
      homeButtonText: '홈으로 돌아가기',
      showErrorDetails: true,
      redirectToHome: '/',
      redirectToCart: '/cart'
    }
  },
  category: 'payment', // 컴포넌트 카테고리
  icon: '❌', // 대표 아이콘
  name: '결제 실패' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as PaymentFailComponent } from './PaymentFail.component';
export { default as PaymentFailEditor } from './PaymentFail.editor';
export { default as PaymentFailProperties } from './PaymentFail.properties';
export * from './PaymentFail.types'; 